webpackJsonp([203135278815170,60335399758886],{

/***/ 81:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"pathPrefix":"/react-permissible","siteMetadata":{"title":"Brainhub template","description":"Default template for open-source libraries","image":"https://cdn-images-1.medium.com/max/1200/1*CLUFZFaXF6NG27NA3d_JkQ.jpeg","url":"https://screencloud.dev.brainhub.pl/","type":"article","siteName":"Brainhub template","githubUrl":"https://github.com/brainhubeu"}},"allMarkdownRemark":{"edges":[{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/oneMatch.md","headings":[{"value":"Render a component when one of the permissions matches","depth":1}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/renderOtherwise.md","headings":[{"value":"Render another component if the permissions do not match","depth":1}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/callback.md","headings":[{"value":"Callback function","depth":1}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/permissionsMatch.md","headings":[{"value":"Render a component when all the permissions match","depth":1}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/getting-started/installation.md","headings":[{"value":"Installation","depth":1}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/getting-started/overview.md","headings":[{"value":"react-permissible","depth":1},{"value":"Making the permission management for components easier.","depth":4},{"value":"Why","depth":2}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/usage/basic.md","headings":[{"value":"Usage","depth":1},{"value":"Use as an ordinary component with props:","depth":2}]}},{"node":{"fileAbsolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/usage/hoc.md","headings":[{"value":"Usage","depth":1},{"value":"Usage as a Higher Order Component:","depth":2}]}}]},"menu":{"pages":[{"title":"Home","dir":"./src","url":"/","file":"pages/landing.js","relativePath":"src/pages/landing.js","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs-www/src/pages/landing.js","sidemenu":[]},{"title":"Docs","dir":"../docs","url":"/docs/getting-started/overview","sidemenu":[{"title":"Getting Started","dir":"getting-started","items":[{"title":"Overview","file":"overview.md","relativePath":"../docs/getting-started/overview.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/getting-started/overview.md","items":[],"url":"/docs/getting-started/overview"},{"title":"Installation","file":"installation.md","relativePath":"../docs/getting-started/installation.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/getting-started/installation.md","items":[],"url":"/docs/getting-started/installation"}],"relativePath":null,"absolutePath":null,"url":"/docs/getting-started/overview"},{"title":"Usage","dir":"usage","items":[{"title":"As an ordinary component","file":"basic.md","relativePath":"../docs/usage/basic.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/usage/basic.md","items":[],"url":"/docs/usage/basic"},{"title":"As Higher Order Component","file":"hoc.md","relativePath":"../docs/usage/hoc.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/usage/hoc.md","items":[],"url":"/docs/usage/hoc"}],"relativePath":null,"absolutePath":null,"url":"/docs/usage/basic"},{"title":"Examples","dir":"examples","items":[{"title":"Render component when all the permissions match","file":"permissionsMatch.md","relativePath":"../docs/examples/permissionsMatch.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/permissionsMatch.md","items":[],"url":"/docs/examples/permissionsMatch"},{"title":"Render component when one of the permissions match","file":"oneMatch.md","relativePath":"../docs/examples/oneMatch.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/oneMatch.md","items":[],"url":"/docs/examples/oneMatch"},{"title":"Render another component if the permissions do not match","file":"renderOtherwise.md","relativePath":"../docs/examples/renderOtherwise.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/renderOtherwise.md","items":[],"url":"/docs/examples/renderOtherwise"},{"title":"Callback function","file":"callback.md","relativePath":"../docs/examples/callback.md","absolutePath":"/Users/krystian/Dev/brainhubeu-react-permissible/docs/examples/callback.md","items":[],"url":"/docs/examples/callback"}],"relativePath":null,"absolutePath":null,"url":"/docs/examples/permissionsMatch"}],"relativePath":null,"absolutePath":null}]}},"layoutContext":{}}

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _default = __webpack_require__(140);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _layoutDefault = __webpack_require__(81);
	
	var _layoutDefault2 = _interopRequireDefault(_layoutDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_default2.default, _extends({}, props, _layoutDefault2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(246);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'p',
	  null,
	  '\xA9 2018 Maintained by ',
	  _react2.default.createElement(
	    'a',
	    { href: 'https://brainhub.eu' },
	    'Brainhub'
	  )
	);
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _footerModule2.default.footer },
	    _ref
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  "svg",
	  { height: "32", viewBox: "0 0 16 16", version: "1.1", width: "32", fill: "#fff" },
	  _react2.default.createElement("path", { fillRule: "evenodd", d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" })
	);
	
	var GithubIcon = function GithubIcon() {
	  return _ref;
	};
	
	exports.default = GithubIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(89);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuProptypes = __webpack_require__(87);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _GithubIcon = __webpack_require__(135);
	
	var _GithubIcon2 = _interopRequireDefault(_GithubIcon);
	
	var _headerModule = __webpack_require__(247);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement('rect', { x: '0.38', y: '-0.38', width: '2.58', height: '3.33', transform: 'translate(0.38 2.96) rotate(-90)' });
	
	var _ref2 = _react2.default.createElement('rect', { x: '6.84', y: '12.2', width: '2.58', height: '2.58', transform: 'translate(-5.36 21.63) rotate(-90)' });
	
	var _ref3 = _react2.default.createElement('rect', { x: '63.57', width: '2.58', height: '2.58', transform: 'translate(63.57 66.15) rotate(-90)' });
	
	var _ref4 = _react2.default.createElement('polygon', { points: '14.09 0 11.3 0 6.02 0 6.02 2.58 11.3 2.58 14.09 2.58 20.93 2.58 20.93 0 14.09 0' });
	
	var _ref5 = _react2.default.createElement('rect', { x: '0.86', y: '11.35', width: '2.58', height: '4.29', transform: 'translate(-11.35 15.64) rotate(-90)' });
	
	var _ref6 = _react2.default.createElement('rect', { x: '7.39', y: '1.98', width: '2.58', height: '10.83', transform: 'translate(1.29 16.07) rotate(-90)' });
	
	var _ref7 = _react2.default.createElement('path', { d: 'M86.66,4.41H86.2a9.44,9.44,0,0,0-2.26.36V.69H81.28V14.79h2.66v-7a3.08,3.08,0,0,1,2.26-.84,1.25,1.25,0,0,1,1.07.43,2.44,2.44,0,0,1,.32,1.43v6h2.69V8.68C90.27,6,89.06,4.5,86.66,4.41Z' });
	
	var _ref8 = _react2.default.createElement('path', { d: 'M110.45,4.41H110a9.44,9.44,0,0,0-2.26.36V.69h-2.66V14.79h2.66v-.36A5.74,5.74,0,0,0,110,15h.46c2.4-.09,3.62-1.6,3.62-4.27V8.68C114.06,6,112.85,4.5,110.45,4.41Zm.93,6.24a2.44,2.44,0,0,1-.32,1.43,1.25,1.25,0,0,1-1.07.43,3.08,3.08,0,0,1-2.26-.84V7.74A3.08,3.08,0,0,1,110,6.89a1.25,1.25,0,0,1,1.07.43,2.44,2.44,0,0,1,.32,1.43Z' });
	
	var _ref9 = _react2.default.createElement('path', { d: 'M55,4.41c-2.4.09-3.62,1.6-3.62,4.27v2.05c0,2.67,1.21,4.18,3.62,4.27h.46a7.19,7.19,0,0,0,2.26-.46v.4h2.66V6.2a7.46,7.46,0,0,0-4.91-1.78Zm2.72,7.26a3.08,3.08,0,0,1-2.26.84,1.25,1.25,0,0,1-1.07-.43,2.45,2.45,0,0,1-.32-1.43V8.76a2.45,2.45,0,0,1,.32-1.43,1.25,1.25,0,0,1,1.07-.43,3.08,3.08,0,0,1,2.26.84Z' });
	
	var _ref10 = _react2.default.createElement('rect', { x: '63.54', y: '4.82', width: '2.64', height: '9.97' });
	
	var _ref11 = _react2.default.createElement('path', { d: 'M40.1,7.19A4.32,4.32,0,0,0,36.85,0H31V14.79h6.22a4.32,4.32,0,0,0,2.85-7.6ZM36.85,2.58a1.76,1.76,0,1,1,0,3.52H33.62V2.58Zm.4,9.62H33.62V8.68h3.64a1.76,1.76,0,1,1,0,3.52Z' });
	
	var _ref12 = _react2.default.createElement('path', { d: 'M74.61,4.41h-.46A7.46,7.46,0,0,0,69.24,6.2v8.58h2.66v-7a3.08,3.08,0,0,1,2.26-.84,1.25,1.25,0,0,1,1.07.43,2.44,2.44,0,0,1,.32,1.43v6h2.69V8.68C78.23,6,77,4.5,74.61,4.41Z' });
	
	var _ref13 = _react2.default.createElement('path', { d: 'M99.14,11.79a3.08,3.08,0,0,1-2.26.84,1.25,1.25,0,0,1-1.07-.43,2.45,2.45,0,0,1-.32-1.43v-6H92.8v6.11c0,2.67,1.21,4.18,3.62,4.27h.46a7.46,7.46,0,0,0,4.91-1.78V4.74H99.14Z' });
	
	var _ref14 = _react2.default.createElement('path', { d: 'M48.78,4.69a7.46,7.46,0,0,0-4.91,1.78v8.32h2.66V8a3.16,3.16,0,0,1,2.27-.89,6.18,6.18,0,0,1,1.14.09V4.69H48.78Z' });
	
	var _ref15 = _react2.default.createElement('rect', { x: '17.51', y: '5.26', width: '2.58', height: '4.26', transform: 'translate(11.41 26.2) rotate(-90)' });
	
	var _ref16 = _react2.default.createElement('rect', { x: '15.2', y: '9.05', width: '2.58', height: '8.89', transform: 'translate(2.99 29.98) rotate(-90)' });
	
	var _ref17 = _react2.default.createElement(_GithubIcon2.default, null);
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      var listChildren = Array.from(_this.listRef.current.children[0].children);
	      _this.listItemWidth = _this.getItemListWidth(listChildren);
	
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	
	      window.addEventListener('resize', _this.updateDimensions);
	    };
	
	    _this.updateDimensions = function () {
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	    };
	
	    _this.getItemListWidth = function (navArray) {
	      var navWidth = 0;
	
	      navArray.forEach(function (element) {
	        navWidth += element.clientWidth;
	      });
	
	      return navWidth;
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuIsOpen: !_this.state.menuIsOpen });
	    };
	
	    _this.listRef = _react2.default.createRef();
	    _this.listItemWith = 0;
	
	    _this.state = {
	      mobileMenu: false,
	      mainNavItemsWidth: 0,
	      menuIsOpen: false
	    };
	    return _this;
	  }
	
	  Header.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateDimensions);
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        menuPages = _props.menuPages,
	        activeNavTitle = _props.activeNavTitle,
	        githubUrl = _props.githubUrl;
	
	    return _react2.default.createElement(
	      'header',
	      {
	        className: (0, _classnames2.default)([_headerModule2.default.header, this.state.mobileMenu && _headerModule2.default['header--mobile']])
	      },
	      _react2.default.createElement(
	        'svg',
	        { width: '119px', height: '16px', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 114.06 15.12', fill: '#fff', className: _headerModule2.default.header__logo },
	        _ref,
	        _ref2,
	        _ref3,
	        _ref4,
	        _ref5,
	        _ref6,
	        _ref7,
	        _ref8,
	        _ref9,
	        _ref10,
	        _ref11,
	        _ref12,
	        _ref13,
	        _ref14,
	        _ref15,
	        _ref16
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.header__menuWrapper },
	        _react2.default.createElement(
	          'nav',
	          { className: _headerModule2.default.header__nav, ref: this.listRef },
	          _react2.default.createElement(
	            'ul',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.nav__list, this.state.menuIsOpen && _headerModule2.default['nav__list--mobile__open']])
	
	            },
	            menuPages.map(function (element, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: index, className: _headerModule2.default.nav__item },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: element.url,
	                    className: (0, _classnames2.default)([_headerModule2.default.nav__link, activeNavTitle === element.title ? _headerModule2.default['nav__link--active'] : null]),
	                    'data-after': element.title,
	                    onClick: _this2.toggleMenu
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    element.title
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.menu__btnsWrapper },
	          githubUrl && _react2.default.createElement(
	            'a',
	            { href: githubUrl, target: '_blank', className: _headerModule2.default.header__github },
	            _ref17
	          ),
	          this.state.mobileMenu && _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.header__mobileBtn, this.state.menuIsOpen && _headerModule2.default['header__mobileBtn--active']]),
	              onClick: this.toggleMenu
	            },
	            _react2.default.createElement('span', { className: _headerModule2.default.mobileBtn__hamburger })
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header---1mTiD","header--mobile":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header--mobile---39TZN","nav__list":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---nav__list---WOuNM","nav__list--mobile__open":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---nav__list--mobile__open---1IE1o","fromTop":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---fromTop---EXY3R","nav__item":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---nav__item---1_LeE","nav__link":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---nav__link---3iHHb","header__logo":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__logo---3zan7","header__menuWrapper":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__menuWrapper---j7IKh","header__nav":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__nav---23QwV","opacity":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---opacity---2gw6P","nav__link--active":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---nav__link--active---2O7WQ","menu__btnsWrapper":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---menu__btnsWrapper---3l1KP","header__mobileBtn":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__mobileBtn---3f-N-","mobileBtn__hamburger":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---mobileBtn__hamburger---_FcY-","header__mobileBtn--active":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__mobileBtn--active---TMFJk","header__github":"node_modules--brainhubeu-gatsby-docs-kit-src-components-header----header-module---header__github---1YL-L"};

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainModule = __webpack_require__(248);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'main',
	    { className: _mainModule2.default.main },
	    children()
	  );
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"node_modules--brainhubeu-gatsby-docs-kit-src-components-main----main-module---main---25yzl"};

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(329);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_React$Component) {
	  _inherits(SEO, _React$Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var siteMetadata = this.props.siteMetadata;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        siteMetadata.title
	      ),
	      siteMetadata.description && _react2.default.createElement('meta', { name: 'description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { name: 'image', content: siteMetadata.image }),
	      siteMetadata.siteName && _react2.default.createElement('meta', { property: 'og:site_name', content: siteMetadata.siteName }),
	      siteMetadata.url && _react2.default.createElement('meta', { property: 'og:url', content: siteMetadata.url }),
	      siteMetadata.type && _react2.default.createElement('meta', { property: 'og:type', content: siteMetadata.type }),
	      siteMetadata.title && _react2.default.createElement('meta', { property: 'og:title', content: siteMetadata.title }),
	      siteMetadata.description && _react2.default.createElement('meta', { property: 'og:description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { property: 'og:image', content: siteMetadata.image })
	    );
	  };
	
	  return SEO;
	}(_react2.default.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(89);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sideNavModule = __webpack_require__(249);
	
	var _sideNavModule2 = _interopRequireDefault(_sideNavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createMenuList = function createMenuList(listData, location) {
	  return _react2.default.createElement(
	    'ul',
	    { className: _sideNavModule2.default.sideNav__sideList },
	    listData.map(function (element) {
	      return _react2.default.createElement(
	        'li',
	        { key: element.title, className: _sideNavModule2.default.sideList__item },
	        element.file && _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: element.url || element.href,
	            className: (0, _classnames2.default)([_sideNavModule2.default.subNav__link, location === element.url && _sideNavModule2.default['subNav__link--active']])
	          },
	          element.title
	        ),
	        !element.file && _react2.default.createElement(
	          'span',
	          { className: _sideNavModule2.default.subNav__header },
	          element.title
	        ),
	        element.items && createMenuList(element.items, location)
	      );
	    })
	  );
	};
	
	var SideNav = function SideNav(_ref) {
	  var activeNavData = _ref.activeNavData,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    { className: _sideNavModule2.default.sideNav__scrollableWrapper },
	    _react2.default.createElement(
	      'nav',
	      { className: _sideNavModule2.default.sideNav },
	      createMenuList(activeNavData.sidemenu, location)
	    )
	  );
	};
	
	exports.default = SideNav;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sideNav":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---sideNav---7isTm","sideNav__scrollableWrapper":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---sideNav__scrollableWrapper---12Tf3","sideNav__sideList":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---sideNav__sideList---2GfW2","subNav__header":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---subNav__header---2fS7R","subNav__link":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---subNav__link---1xZ-x","subNav__link--active":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---subNav__link--active---Mleh3","sideNav__slideList":"node_modules--brainhubeu-gatsby-docs-kit-src-components-sideNav----sideNav-module---sideNav__slideList---3Bf8W"};

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _menuProptypes = __webpack_require__(87);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _navigation = __webpack_require__(142);
	
	var _Header = __webpack_require__(136);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SideNav = __webpack_require__(139);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Main = __webpack_require__(137);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(134);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _sideMenu = __webpack_require__(143);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _seo = __webpack_require__(138);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	__webpack_require__(320);
	
	__webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPathName = function getPathName(location) {
	  var pathNamePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var pathName = location.pathname;
	
	  if (pathName === '/') {
	    return pathName;
	  }
	
	  if (pathNamePrefix && pathNamePrefix.trim() && pathName.startsWith(pathNamePrefix)) {
	    pathName = pathName.substring(pathNamePrefix.length, pathName.length);
	  }
	
	  if (pathName.substring(pathName.length - 1) === '/') {
	    pathName = pathName.substring(0, pathName.length - 1);
	  }
	
	  return pathName;
	};
	
	var _ref = _react2.default.createElement(_Footer2.default, null);
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location;
	
	    var pathName = getPathName(location, this.props.data.site.pathPrefix);
	
	    var activeData = (0, _navigation.findMatchingPage)(this.props.data.menu.pages, pathName);
	
	    if (activeData && activeData.file && !(0, _sideMenu.hasSideMenu)(activeData)) {
	      activeData.sidemenu = (0, _sideMenu2.default)(activeData, data);
	    }
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_seo2.default, { siteMetadata: data.site.siteMetadata }),
	      _react2.default.createElement(_Header2.default, {
	        menuPages: data.menu.pages || [],
	        activeNavTitle: activeData && activeData.title,
	        githubUrl: data.site.siteMetadata.githubUrl
	      }),
	      (0, _sideMenu.hasSideMenu)(activeData) && _react2.default.createElement(_SideNav2.default, { activeNavData: activeData, location: pathName + location.hash }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Main2.default,
	          null,
	          children
	        ),
	        _ref
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;
	
	// @TODO Figure out way to avoid globals
	// eslint-disable-next-line no-undef
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuPropTypes = {
	  title: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  hash: _propTypes2.default.string
	};
	
	exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	  title: _propTypes2.default.string,
	  dir: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  template: _propTypes2.default.string,
	  layout: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  sidemenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	      items: _propTypes2.default.arrayOf(_propTypes2.default.shape(menuPropTypes))
	    })))
	  })))
	}));
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.findMatchingPage = findMatchingPage;
	
	/**
	 * Retrieve all url's from menu
	 * @param {Array} menuItems
	 * @return {Array} urls
	 */
	function getAllUrls(menuItems) {
	  if (!menuItems) {
	    return [];
	  }
	
	  return menuItems.reduce(function (acc, menuItem) {
	    acc.push(menuItem.url);
	
	    if (menuItem.items) {
	      acc.push.apply(acc, getAllUrls(menuItem.items));
	    }
	
	    return acc;
	  }, []);
	}
	
	/**
	 * Find page, that matches location pathname
	 * @param {Array} menuItems
	 * @param {String} pathname location pathname
	 * @param {String} prefix
	 * @return {Object} page config
	 */
	function findMatchingPage(menuItems, pathname) {
	  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (!menuItems) {
	    return false;
	  }
	
	  if (!pathname.startsWith(prefix)) {
	    return false;
	  }
	
	  var pathNameWithoutPrefix = pathname.substr(prefix.length);
	
	  return menuItems.find(function (menuItem) {
	    if (!menuItem) {
	      return false;
	    }
	
	    return pathNameWithoutPrefix === menuItem.url || getAllUrls(menuItem.sidemenu || menuItem.items).indexOf(pathNameWithoutPrefix) !== -1;
	  });
	}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var GithubSlugger = __webpack_require__(298);
	
	var addItemToMenu = function addItemToMenu(sidemenu, file, url, hash, title, depth, currentDepth) {
	  currentDepth = currentDepth || 2; // h1 are excluded
	
	  if (depth === currentDepth) {
	    sidemenu.push({ file: file, url: '' + url + hash, title: title, items: [] });
	  } else {
	    currentDepth++;
	    var last = sidemenu.pop();
	    if (last) {
	      addItemToMenu(last.items, file, url, hash, title, depth, currentDepth);
	      sidemenu.push(last);
	    }
	  }
	};
	
	var createSideMenu = function createSideMenu(activeData, data) {
	  var slugger = new GithubSlugger();
	  activeData.depthOfMenu = (activeData.depthOfMenu || 6) + 1; // menu starts from h2
	  var sidemenu = [];
	
	  var matchedMarkdownEdge = data.allMarkdownRemark.edges.find(function (edge) {
	    return edge.node.fileAbsolutePath === activeData.absolutePath;
	  });
	
	  if (!matchedMarkdownEdge) {
	    return [];
	  }
	
	  matchedMarkdownEdge.node.headings.filter(function (child) {
	    return child.depth >= 2 && child.depth <= activeData.depthOfMenu;
	  }).map(function (child) {
	    return {
	      hash: '#' + slugger.slug(child.value),
	      depth: child.depth,
	      value: child.value
	    };
	  }).map(function (child) {
	    return addItemToMenu(sidemenu, activeData.file, activeData.url, child.hash, child.value, child.depth);
	  });
	  return sidemenu;
	};
	
	exports.default = createSideMenu;
	
	/**
	 * Determines whether page has sidemenu
	 * @param {Object} page
	 * @return {Boolean}
	 */
	
	var hasSideMenu = exports.hasSideMenu = function hasSideMenu(page) {
	  return !!page && !!page.sidemenu && !!page.sidemenu.length;
	};

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(236);
	var isArguments = __webpack_require__(235);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	module.exports = function() {
		return /[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uD83C\uDDFE\uD83C[\uDDEA\uDDF9]|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDFC\uD83C[\uDDEB\uDDF8]|\uD83C\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uD83C\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF8\uDDFE\uDDFF]|\uD83C\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uD83C\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uD83C\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uD83C\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uD83C\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uD83C\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uD83C\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uD83C\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uD83C\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uD83C\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uD83C\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uD83C\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uD83C\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uD83C\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uD83C\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uD83C\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|[#\*0-9]\u20E3/g;
	};


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	var emoji = __webpack_require__(244)
	
	module.exports = BananaSlug
	
	function BananaSlug () {
	  var self = this
	  if (!(self instanceof BananaSlug)) return new BananaSlug()
	
	  self.reset()
	}
	
	/**
	 * Generate a unique slug.
	 * @param  {string} value String of text to slugify
	 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
	 * @return {string}       A unique slug string
	 */
	BananaSlug.prototype.slug = function (value, maintainCase) {
	  maintainCase = maintainCase === true
	  var self = this
	  var slug = slugger(value, maintainCase)
	  var occurrences = self.occurrences[slug]
	
	  if (self.occurrences.hasOwnProperty(slug)) {
	    occurrences++
	  } else {
	    occurrences = 0
	  }
	
	  self.occurrences[slug] = occurrences
	
	  if (occurrences) {
	    slug = slug + '-' + occurrences
	  }
	
	  return slug
	}
	
	/**
	 * Reset - Forget all previous slugs
	 * @return void
	 */
	BananaSlug.prototype.reset = function () {
	  this.occurrences = {}
	}
	
	var whitespace = /\s/g
	
	function lower (string) {
	  return string.toLowerCase()
	}
	
	function slugger (string, maintainCase) {
	  var re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g
	  var replacement = '-'
	
	  if (typeof string !== 'string') return ''
	  if (!maintainCase) string = string.replace(/[A-Z]+/g, lower)
	  return string.trim()
	    .replace(re, '')
	    .replace(emoji(), '')
	    .replace(whitespace, replacement)
	}


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(332);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(234);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(330);
	
	var _HelmetConstants = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(82);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(245));
	var shallowEqual = _interopDefault(__webpack_require__(338));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ })

});


// WEBPACK FOOTER //
// component---node-modules-brainhubeu-gatsby-docs-kit-src-layouts-default-js-177a6711e3b69d65de0a.js